import { useEffect } from "react";
import { useSelector } from "react-redux";
import { IRootState } from "../store";

export const usePageTitle = (baseTitle: string) => {
  const { total_unread } = useSelector((state: IRootState) => state.notify);

  useEffect(() => {
    const title = total_unread > 0 ? `(${total_unread}) ${baseTitle} | Laundry` : `${baseTitle} | Laundry`;

    document.title = title;
  }, [total_unread, baseTitle]);
};
